const scrollTo = (elementId) => {
  if (!elementId) return;
  let element = document.getElementById(elementId);

  element?.scrollIntoView({ behavior: "smooth" });
  element?.focus(); // if focusable then it will focus automatically
};
export default scrollTo;
